import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import Axios from "axios";
import url from "../../services/url";
import ClipboardJS from "clipboard/dist/clipboard";
import { Link, useHistory, useLocation } from "react-router-dom";
import LoadingArea from "../../components/LoadingArea";
import swal from "sweetalert";
import isAdmin from "../../services/isAdmin";
import isConsultant from "../../services/isConsultant";
//import swal from '@sweetalert/with-react'

import axios from "../../services/axios";
import { result } from "lodash";
import { Input, Table, Tooltip } from "antd";
import useAxios from "../../hooks/useAxios";
import { SearchOutlined } from "@ant-design/icons";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

const RIGHTS = [
  "abhishek.vashisht@maxicus.com",
  "sarbjeet.singh@igzy.com",
  "manish@gmail.com",
  "vishalmahajan51@yahoo.com",
  "abhishek.poddar@kocharsoft.com",
  "abhishek.kp6239@gmail.com",
];

function Forms() {
  // States
  const history = useHistory();
  const api = useAxios();
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sendModal, setSendModal] = useState(false);
  const [sendForm, setSendForm] = useState("");
  const [sendWhatsapp, setSendWhatsapp] = useState("sms");
  const [sendPhoneNumber, setSendPhoneNumber] = useState("+91");
  const [formName, setFormName] = useState("");

  const userRole = useRole();
  const [canEdit, setCanEdit] = useState(false);
  const [canDuplicate, setCanDuplicate] = useState(false);
  const [canCopy, setCanCopy] = useState(false);

  const checkPermissions = async () => {
    try {
      const editAllowed = await checkPermission(
        userRole,
        "forms_module",
        "edit_form"
      );
      const duplicateAllowed = await checkPermission(
        userRole,
        "forms_module",
        "duplicate_form"
      );
      const copyAllowed = await checkPermission(
        userRole,
        "forms_module",
        "copy_form"
      );
      setCanEdit(editAllowed);
      setCanDuplicate(duplicateAllowed);
      setCanCopy(copyAllowed);
    } catch (err) {
      console.error("Error checking permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);
  
  const columns = [
    {
      title: "Form Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.name.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Form Type",
      dataIndex: "formType",
      key: "formType",
      sorter: (a, b) => a?.formType?.localeCompare(b?.formType),
      render: (value, record) => {
        return (
          <>{`${record.formType?.split("_")[0]} ${
            record.formType?.split("_")[1] !== undefined
              ? record.formType?.split("_")[1]
              : ""
          }`}</>
        );
      },
    },
    {
      title: "Form Link",
      dataIndex: "formLink",
      key: "formLink",
      sorter: (a, b) => a?.formLink?.localeCompare(b?.formLink),
      render: (value, record) => {
        return (
          <a
            href={
              window.location.origin +
              "/forms/" +
              record?._id +
              "?formname=" +
              record?.name.split(" ").join("-") +
              "&mobileno=" +
              "" +
              "&source=" +
              ""
            }
            target="_blank"
          >
            {record?._id} <i class="fa fa-external-link" aria-hidden="true"></i>
          </a>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (value, record) => {
        return (
          <div className="d-flex gap-1">
            {canCopy && (
              <button
                className="btn btn-secondary btn-sm mr-1 btn-clipboard"
                data-clipboard-text={
                  window.location.origin +
                  "/forms/" +
                  record._id +
                  "?formname=" +
                  record.name.split(" ").join("-") +
                  "&mobileno=" +
                  "" +
                  "&source=" +
                  ""
                }
              >
                <i class="fas fa-copy"></i> Copy
              </button>
            )}
            {canDuplicate && (
              <button
                className="btn btn-primary btn-sm mr-1"
                onClick={() => onClickDuplicate(record)}
              >
                <i class="fa fa-clone" aria-hidden="true"></i> Duplicate
              </button>
            )}
            {/* <button
                          className="btn btn-info btn-sm mr-1"
                          onClick={() => onClickSend(record)}
                          data-target="#sendModal"
                          data-toggle="modal"
                        >
                          <i class="fa fa-paper-plane" aria-hidden="true"></i>{" "}
                          Send
                        </button> */}
            {/* <Link to={"form/" + record._id + "/contacts/" + "form"}>
                      <Button className="mr-1" color="primary" size="sm">
                        Contacts
                      </Button>
                    </Link> */}
            {canEdit && (
              <Link to={`/form-template/edit/${record._id}`}>
                <button className="btn btn-info btn-sm mr-1">
                  <i class="fa fa-edit"></i> Edit
                </button>
              </Link>
            )}
            {/* {localStorage.getItem("user.role") === "admin"  && (
                          <button
                            className="btn btn-danger btn-sm mr-1"
                            form={record._id}
                            onClick={onClickDeleteForm}
                            disabled={true}
                          >
                            <i class="fa fa-trash" aria-hidden="true"></i>{" "}
                            Delete
                          </button>
                        )} */}
          </div>
        );
      },
    },
  ];

  async function fetchData() {
    try {
      setLoading(true);
      const { data } = await api.get(`/formtemplate`, {
        tokenType: "user",
      });
      setForms(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    new ClipboardJS(".btn-clipboard");
    fetchData();
    localStorage.removeItem("Name");
    localStorage.removeItem("Email");
  }, []);

  // Events

  function refresh() {
    window.location.reload(true);
  }

  function onClickDeleteForm(e) {
    Axios.delete(url("formtemplate/" + e.target.getAttribute("form")), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    });
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover the candidate!",
      icon: "error",

      //buttons: true,
      //dangerMode: true,
    })
      .then((res) => {
        history.go(0);
      })
      .catch(console.error);
    e.persist();

    swal({
      title: "Are you sure ?",
      icon: "warning",
      text: "You will not be able to recover this form",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Successfully Deleted", {
          icon: "success",
        });

        Axios.delete(url("formtemplate/" + e.target.getAttribute("form")), {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        });
      }
      fetchData();
      refresh();
    });
  }

  async function onClickDuplicate(form) {
    try {
      const results = await swal({
        title: "Duplicate Form",
        text: `Form Name is required field.`,
        html: true,
        required: true,
        content: "input",
        buttons: true,
        dangerMode: true,
      });

      if (results.trim() !== "" && results !== undefined && results !== null) {
        await axios.post(
          "/formtemplate/duplicate",
          {
            name: results,
            form: form._id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          }
        );
        refresh();
      } else if (results === "" || results.trim() === "") {
        onClickDuplicate(form);
      }

      fetchData();
    } catch (e) {
      console.error(e);
    }
  }

  async function onClickSend(form) {
    setSendForm(form._id);
  }

  async function onClickSendSMS() {
    try {
      await axios.post(
        "/formtemplate/" + sendForm + "/message",
        {
          type: sendWhatsapp,
          phoneNumber: sendPhoneNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      );
      swal({ icon: "success", text: "Message Sent!" });
    } catch (e) {
      console.log(e);
    }
  }

  // const num = ""
  // // Encode the String
  // var encryptedNum = btoa(num);
  // var encryptedSource = btoa(source);
  //Decode the string
  //var decodedNum = atob(encryptedNum);

  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="Forms">
          <LoadingArea isLoading={loading}>
            <div className="d-flex justify-content-between align-items-center py-1 mb-3">
              <h4 className="fw-normal">All Forms</h4>
            </div>
            <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
              <Table
                columns={columns}
                dataSource={forms}
                pagination={{
                  total: forms?.length,
                  pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
                  showSizeChanger: false,
                  // current: current,
                  // onChange: onChange,
                }}
                // onRow={(record) => ({
                //   onClick: async () => {
                //     getCandidate(record?.candidate,record?.key)
                //   },
                // })}
                showSorterTooltip={false}
                scroll={{ x: true }}
                style={{ whiteSpace: "pre", width: "100%" }}
                exportFileName="details"
                size="small"
              />
            </div>
            <div id="sendModal" className="modal" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Send Form</h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label htmlFor="form">Form</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={sendForm}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="useWhatsapp">Send Via</label>
                      <select
                        className="form-control"
                        name="useWhatsapp"
                        id="useWhatsapp"
                        value={sendWhatsapp}
                        onChange={(e) => setSendWhatsapp(e.target.value)}
                      >
                        <option value="sms">SMS</option>
                        <option value="whatsapp">Whatsapp</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="form">Phone Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={sendPhoneNumber}
                        onChange={(e) => setSendPhoneNumber(e.target.value)}
                      />
                      <small className="text-muted">
                        Sending a message will incur charges.
                      </small>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={onClickSendSMS}
                      data-dismiss="modal"
                    >
                      Send
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </LoadingArea>
        </Dashboard>
      )}
    </div>
  );
}

export default Forms;
